import React from 'react'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { parsedCurrentSheetAtom } from './atoms'
import { Column } from 'shared/ui/Table/types'
import { Table } from 'shared/ui/Table/Table'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Tooltip,
} from '@mui/material'

const CONTENT_CUTOFF = 125

export function RawDataTable() {
  const rawData = useAtomValue(parsedCurrentSheetAtom)?.rawData
  if (!rawData) return null
  const columns = rawData.headers.map<Column<string[]>>((title, index) => {
    return {
      title,
      rowContent(param: string[]) {
        return (
          <Tooltip
            title={param[index]}
            disableHoverListener={
              !!param[index] && param[index].length < CONTENT_CUTOFF
            }
          >
            <span>
              <span>{param[index]?.slice(0, CONTENT_CUTOFF)}</span>
              {param[index]?.length >= CONTENT_CUTOFF && <span>....</span>}
            </span>
          </Tooltip>
        )
      },
      rowString(param: string[]) {
        return param[index]
      },
    }
  })

  return (
    <Accordion>
      <AccordionSummary>
        Imported Spreadsheet: View original spreadsheet
      </AccordionSummary>
      <AccordionDetails>
        {!!columns.length && (
          <Table canExport={true} items={rawData.data} columns={columns} />
        )}
        {!columns.length && <Box>Error getting data from sheet</Box>}
      </AccordionDetails>
    </Accordion>
  )
}
